import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {uploadIncomingExcel} from "../../../../../api/inventory/IncomingApi";

export const useUploadIncomingExcel = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: FormData) => uploadIncomingExcel(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
